import { Link } from "react-router";
import type { Game } from "../types/Game";
import { GameCard } from "./GameCard";

interface GameRowProps {
	title: string;
	games: Game[];
	/** Optional "See all" link target. */
	seeAllHref?: string;
}

/**
 * Netflix-style horizontal scroll row. Used on the home page for Featured,
 * Trending, and New Releases. Shows as a regular row on large screens and a
 * swipeable horizontal list on mobile.
 */
export function GameRow({ title, games, seeAllHref }: GameRowProps) {
	if (games.length === 0) return null;
	return (
		<section className="space-y-5">
			<div className="flex items-end justify-between gap-4">
				<h2 className="font-display font-bold text-xl md:text-2xl text-ink">
					{title}
				</h2>
				{seeAllHref && (
					<Link
						to={seeAllHref}
						className="text-sm font-medium text-primary hover:underline shrink-0"
					>
						See all
					</Link>
				)}
			</div>
			<div className="-mx-4 px-4 md:mx-0 md:px-0">
				<div className="flex gap-4 md:gap-5 overflow-x-auto no-scrollbar pb-2 snap-x snap-mandatory">
					{games.map((g) => (
						<div
							key={g.id}
							className="shrink-0 w-[68%] sm:w-[44%] md:w-[30%] lg:w-[23%] snap-start"
						>
							<GameCard game={g} />
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
